<div class="sub-header px-3">
</div>
<div class="search-container py-3 align-items-center d-flex row px-3 mb-1 pb-4">
    <div class="col-md-6 catalog-header d-flex px-3 py-1">
        <h5 class="mb-0 px-0">Associate Customers to Site</h5>
    </div>
    <div class="col-md-6 px-4 search-input-block d-flex align-items-center justify-content-end">
        <ng-container>
            <button  (click)="linkDrawer = !linkDrawer;editData=[];" nz-button nzType="primary" class="d-flex align-items-center" [nzSize]="'default'">
                Associate Customer to Site
            </button>
        </ng-container>
    </div>
</div>
<div class="row bg-white px-4 d-flex align-items-center">
    <div class="px-0 py-2 col-md-12 amd-list-container">
        <div class="col-md-12 px-2 searh-input-block d-flex align-items-center row">
             <div class="col-md-6">
              <nz-input-group class="px-2 mr-2 search-input-group" style="width: 80%;height: 35px;" nzSize="default"
          [nzSuffix]="suffixIconSearch" nzSearch="false">
          <input type="text" class="py-1" nz-input placeholder="Search By AR # / Customer Name"
             [(ngModel)]="searchText"
             nzAllowClear #SearchText  />
          <span class="close-icon" (click)="SearchText.value = '';searchText='';searchCustomer('')" class="px-1" nz-icon
            nzType="close-circle"></span>

        </nz-input-group>
        <ng-template #suffixIconSearch>
          <span class="search-icon" (click)="searchCustomer(SearchText.value)" nz-icon nzType="search"></span>
        </ng-template>
        </div>
        <div class="col-md-4">

        </div>
            <div class="col-md-2 d-flex justify-content-end">
                <button [disabled]="selectedList.length == 0" (click)="deleteSelected()" nz-button nzType="primary"
                    class="d-flex align-items-center" [nzSize]="'default'">
                    <span nz-icon nzType="delete"></span> Delete
                </button>
            </div>
        </div>
        <ng-container>
            <div *ngIf="dataLoaded" class="vh-70">
            <app-spinner ></app-spinner>
            </div>
            <app-data-grid *ngIf="!dataLoaded" [tableHeight]="'65vh'" (editedRow)="editRow($event)" (selectedRows)="selectedRow($event)"
                (deleteRow)="deleteAssociateUser($event)" [columns]="associateCustomerColumns"
                [dataSet]="associateCustomerList" (tableScroll)="onTableScroll($event)" [frontPagination]="false" [gridStyle]="'white'"></app-data-grid>
        </ng-container>
    </div>
</div>
<nz-drawer [nzMaskClosable]="false" [nzWidth]="1200" [nzVisible]="linkDrawer"
    nzTitle="Associate Customers to Site" (nzOnClose)="linkDrawer = false" [nzKeyboard]="false">
    <ng-container *nzDrawerContent>
        <app-add-edit-customer-associate [editData]="editData" (closeDrawer)="closeDrawer()" (emitData)="addData($event)"></app-add-edit-customer-associate>
    </ng-container>
</nz-drawer>
<app-confirm-popup *ngIf="showModal" [title]="'Delete'" message="Are you sure to delete the selected Customer association(s)?" confirmText="Delete"
  [triggerModal]="showModal" [cancelText]="'Cancel'" (confirm)="updateAssociateUserList(payLoadData)"
  (cancel)="showModal =false;"></app-confirm-popup>